// Event type branding for customer-facing emails: the event type's company name, website and
// terms URL (Company Settings → Event Types, e.g. Hen Party → Henit / henit.ie) where set, else the
// company's. Mirrors Company::brandFor in ggb_api so previews match what is sent. FreedomLtd leaves
// these blank, so it keeps the company branding.
//
// Display only: client login/signup URLs must keep the real company.company_name slug.

const pick = (value, fallback) => (value && String(value).trim()) ? String(value).trim() : fallback

export function brandFor(company, eventType) {
    const c = company || {}
    const et = eventType || {}
    return {
        company_name: pick(et.company_name, c.company_name),
        display_name: pick(et.company_name, c.brand_name || c.company_name),
        website: pick(et.website, c.website),
        terms_url: pick(et.terms_url, c.terms_url),
    }
}
